import { Injectable, inject } from '@angular/core';

import { ClientConfigProductName, ManifestService, Page, StylesService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class ProductStylesService {
    private page = inject(Page);
    private stylesService = inject(StylesService);
    private manifestService = inject(ManifestService);

    private alreadyLoaded: ClientConfigProductName[] = [];

    async tryLoad(product: ClientConfigProductName) {
        if (this.alreadyLoaded.includes(product)) {
            return;
        }
        let productStyleBundleKey = this.getProductStyleBundleKey(product);
        let productStylesBundleUrl = this.manifestService.getEntry(productStyleBundleKey);
        if (productStylesBundleUrl) {
            await this.stylesService.loadStyle({ url: productStylesBundleUrl, lazyLoad: 2 });
        }
        this.alreadyLoaded.push(product);
    }

    private getProductStyleBundleKey(product: ClientConfigProductName) {
        return `themes-${this.page.theme}-${product}.css`;
    }
}
